var ModernizrView = function(gal) {
    var _this = this;

    function _cssFilters() {
        if (!Modernizr.cssfilters) {
        	gsCanvas = new GrayscaleCanvas(gal);

        	window.addEventListener('view.onpagechange', function(event) {
        		var $inactiveProds = $(gal.gallery.currItem.container).find('.product-wrap.inactive .p-inner-wrap'),
        			initCanvas = !$inactiveProds.find('canvas').length;

        		
        		if(!!$inactiveProds.length && initCanvas){
					gsCanvas.init();
        		}
        	});
        }
    }

    _this.cssFilters = _cssFilters;
};